// src/api/biz/merchantUser.js
import request from '@/utils/request'

/**
 * 分页查询片商用户
 * GET /biz/merchantUser/page
 * params: pageNum, pageSize, merchantName
 */
export function pageMerchantUser(query) {
    return request({
        url: '/merchant/users/page', // 如果有网关前缀自己改成 /admin-api/biz/merchantUser/page
        method: 'get',
        params: {
            pageNum: query.pageNum,
            pageSize: query.pageSize,
            merchantName: query.merchantName
        }
    })
}

/** 新增片商，对应 /system/users/addFilmUser */
export function addFilmUser(form) {
    return request({
        url: '/system/users/addFilmUser',
        method: 'post',
        data: {
            // 这里是把页面的字段映射成后端需要的字段
            nickName: form.merchantName,
            userName: form.account,
            password: form.password,
            filmGroupCode: form.filmGroupCode
        }
    })
}

/** 编辑片商，对应 /system/users/updateFilmUser */
export function updateFilmUser(form) {
    return request({
        url: '/system/users/updateFilmUser',
        method: 'post',
        data: {
            id: form.id,
            nickName: form.merchantName,
            userName: form.account,
            password: form.password,
            filmGroupCode: form.filmGroupCode
        }
    })
}

/** 冻结 / 启用片商，对应 /system/users/changeStatus */
export function changeFilmUserStatus(id, status) {
    return request({
        url: '/system/users/changeStatus',
        method: 'put',
        data: {
            id: id,
            status: String(status) // 后端是字符串 "0"/"1" 就转一下
        }
    })
}
